import { Phone } from "lucide-react";
import { SITE } from "../data/site";

export const CallFab = () => (
  <a
    href={SITE.phoneHref}
    data-testid="call-fab"
    aria-label={`Call Ms. Jeanette at ${SITE.phone}`}
    className="animate-wiggle fixed bottom-4 right-4 z-40 inline-flex items-center gap-2 rounded-full bg-red-500 px-5 py-3.5 text-sm font-extrabold text-white shadow-xl shadow-red-500/40 focus:outline-none focus:ring-4 focus:ring-red-300 sm:hidden"
  >
    <Phone className="h-5 w-5" aria-hidden="true" />
    Call Ms. Jeanette
  </a>
);
